import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TestTube } from "lucide-react"; // ✅ chemistry icon
import axios from "axios";
import Navbar from "./Navbar";

const ChemistrySummaryNote = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [chemSummary, setChemSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchChemSummary = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://lovencare.gopillz.com/api/chemistry_summary", // ✅ API for chemistry summary
        JSON.stringify({ patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setChemSummary(response.data.summary);
      }
    } catch (error) {
      console.error("Error fetching chemistry summary:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchChemSummary();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-100">
      <Navbar />

      {/* Main Container */}
      <div className="flex justify-center items-start px-4 sm:px-6 md:px-8 pt-28 pb-12">
        <div className="w-full max-w-3xl bg-white rounded-3xl shadow-xl border border-emerald-100 p-6 sm:p-10 transition-all">

          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-emerald-100 p-3 rounded-full shadow-md">
              <TestTube className="w-7 h-7 sm:w-9 sm:h-9 text-emerald-600" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-semibold text-emerald-800">
              Chemistry Summary Note
            </h1>
          </div>

          {/* Chemistry Summary */}
          {isLoading ? (
            <div className="text-center text-emerald-600 font-medium text-lg">
              Loading chemistry summary...
            </div>
          ) : !chemSummary ? (
            <div className="text-center text-gray-600 font-medium text-lg">
              No chemistry summary found for this patient.
            </div>
          ) : (
            <div className="space-y-4">
              <div
                className="relative bg-gradient-to-br from-white/80 to-emerald-50/70 backdrop-blur-md text-gray-800 p-5 sm:p-7 rounded-2xl text-base sm:text-lg border border-emerald-200 shadow-md hover:shadow-lg transition-all duration-300"
              >
                <p className="italic text-gray-600">
                  Notes: {chemSummary || "No notes"}
                </p>
              </div>
            </div>
          )}

          {/* Back Button */}
          <div className="mt-8 text-center">
            <button
              onClick={() => navigate(-1)}
              className="w-full sm:w-auto bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white font-semibold px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
            >
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChemistrySummaryNote;
